import { Button, Box, Select, MenuItem, ListSubheader, TextField, InputAdornment } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux';
import { updateAppState } from '../../../../actions/appstate';
import { useState, useEffect, useMemo } from 'react'
import {
    Search as SearchIcon
} from '@mui/icons-material/'

//menu items needs to be markets
const MarketPicker = () => {

    const { app_state, ui_state } = useSelector(state => state.app.current_state);
    const {current_state} = useSelector(state => state.app);
    const {property_id, property_name, workspace_controls, primary_stay_range, user_view}= current_state.app_state;
  
    const { selected_market, market_settings } = app_state;
    const [market, setMarket] = useState(selected_market.market_id)
    const dispatch = useDispatch();
    useEffect(() => {
        setMarket(app_state.selected_market.market_id);

    }, [app_state])
    // debugger;
    const handleChange = (type,value)=>{
        window.analyze.track("tile_change", {
            "selected_tile": current_state.ui_state.active_tiles.join(),
            ...primary_stay_range,
            property_id, property_name,
            data_view: user_view,selected_market:value
        }, {...current_state}, {app_state: {selected_market:value,data_load:true},ui_state:{showspinner:true}});
        dispatch(updateAppState(type, {app_state: {selected_market:value,data_load:true},ui_state:{showspinner:true}}));
    }
    let label = (ui_state.active_tiles[0] === "market_sell_rates") ? "Locale" : "Market";
    const [searchText, setSearchText] = useState("");
    const allOptions = market_settings;
    const containsText = (text, searchText) =>
        text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

    const displayedOptions = useMemo(
        () => allOptions.filter((option) => containsText(option.label, searchText)),
        [searchText, allOptions]
    );

    return (
        <Box id="market_select" sx={{ backgroundColor: 'blue', height: 1 / 2, maxWidth: 150 }}>
            <Box className="data-level-label">{label} </Box>
            <Box>
                <Select
                    fullWidth
                    value={market}
                    displayEmpty
                    MenuProps={{
                        autoFocus: false,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "center",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "center",
                        },
                        PaperProps: {
                            sx: {maxHeight: "calc(100% - 160px)"},
                        },
                    }}
                    renderValue={() => {
                        const selectedMarket = allOptions.find((option) => option.market_id === market);
                        return selectedMarket ? selectedMarket.label : "Select Market"; // Ensure selected value is always shown
                    }}
                    sx={{ height: "30px", mt: "5px", fontSize: "13px" }}
                    onChange={(e) => {
                        setMarket(e.target.value);
                        const selected_market = allOptions.find((m) => m.market_id === e.target.value);
                        handleChange("market_select", selected_market);
                    }}
                    onClose={() => setSearchText("")}
                >
                    <ListSubheader className='dropdown-search-box'>
                        <TextField
                            size="small"
                            autoFocus
                            placeholder="Type to search..."
                            fullWidth
                            autoComplete="off"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                )
                            }}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                    e.stopPropagation();
                                }
                            }}
                        />
                    </ListSubheader>
                    {displayedOptions
                        .slice()
                        .sort((a, b) => a.label.localeCompare(b.label))
                        .map((market, index) => (
                            <MenuItem className="tabular-data-filter" value={market.market_id} key={index}>
                                {market.label}
                            </MenuItem>
                        ))
                    }
                </Select>
            </Box>
        </Box>
    )
}

export default MarketPicker